export default [
  {id: 'r1', name: 'Remorque de moins de 4 mètres', value: 0},
  {id: 'r2', name: 'Remorque de 4,01 mètres à 6,50 mètres', value: 1},
  {id: 'r3', name: 'Remorque de 6,51 mètres à 7,50 mètres', value: 2},
  {id: 'r4', name: 'Remorque sur 7,51 mètres', value: 3},
]



// WEBPACK FOOTER //
// ./src/shared/routers/languages/fr/arrays/towings.js